import {useEffect, useRef} from "react";
import DropdownUserTypes2 from "root/s360components/ui/DropdownUserTypes2";
import FormFilterWrapper from "root/ReactHookForm/ui/FormFilterWrapper";
import DropdownSchools2 from "root/s360components/ui/DropdownSchools2";
import DropdownLeas, {DEFAULT_LEA} from "root/s360components/ui/DropdownLeas";
import useWatchDropdown from "root/ReactHookForm/ui/useWatchDropdown";

export const UserEditFormSection = 'filters';

export const UserEditFilterNames = {
    LEA: 'lea',
    SCHOOL: 'school',
    USER_TYPE: 'user_type',
}

export const userEditFilterDefaults = () =>
{
    return {
        [UserEditFormSection]:
            {
                [UserEditFilterNames.LEA]: DEFAULT_LEA,
                [UserEditFilterNames.SCHOOL]: null,
                [UserEditFilterNames.USER_TYPE]: null,
            }
    }
}

const UserEditFilters = ({control, resetField, getValues, sectionName}) =>
{
    const [ leaId ] = useWatchDropdown( {control, name: sectionName + '.' + UserEditFilterNames.LEA} ) ;

    //useWatchDropdown resolves its value in an effect, so the LEA is null for the first render.
    //Only a genuine LEA change should clear the downstream filters, not that initial settling.
    const previousLeaId = useRef( null ) ;

    useEffect(() =>
    {
        const hadLea = previousLeaId.current !== null ;

        previousLeaId.current = leaId ;

        if ( hadLea === false )
        {
            return ;
        }

        const current = getValues( sectionName ) ;

        resetField( sectionName, { defaultValue: {
            [UserEditFilterNames.LEA]: current[UserEditFilterNames.LEA],
            [UserEditFilterNames.SCHOOL]: null,
            [UserEditFilterNames.USER_TYPE]: null,
        }});

    }, [leaId])

    return (
        <FormFilterWrapper>
            <DropdownLeas control={control} name={sectionName + '.' + UserEditFilterNames.LEA}
                          placeholder='Please select an LEA' isSearchable={true} key={'dl'}/>
            <DropdownSchools2 control={control} name={sectionName + '.' + UserEditFilterNames.SCHOOL}
                              lea_id={leaId} readOnly={leaId === null}
                              placeholder='Please select a school' isSearchable={true} key={'ds2'}/>
            <DropdownUserTypes2 control={control} name={sectionName + '.' + UserEditFilterNames.USER_TYPE}
                                placeholder='Please select a role' key={'dut2'}/>
        </FormFilterWrapper>
    );

}

export default UserEditFilters;
